module.exports = "define('com/fitbit/app/modules/message.en_US', {\"namespace\":\"com.fitbit.app.modules.message\",\"translations\":{\"chars_remaining_primary_singular\":\"{0} character remaining\",\"chars_remaining_primary_plural\":\"{0} characters remaining\"}});"


/*****************
 ** WEBPACK FOOTER
 ** /tmpfs/src/git/fitbit-site-weightsite/catpack/web_loaders/script-loader/~/raw-loader!../build/assets/i18n/app/modules/message.en_US.js
 ** module id = 18
 ** module chunks = 1 2 4 5
 **/